//文档地址：https://cf.jd.com/pages/viewpage.action?pageId=242773483

const adminNative = function () {};
const emptyFunction = function () {
  console.log("this is empty callback");
};
const errorCallback = function (id) {
  console.log(`原生接口调用错误 typeId:${id}`);
};
// 初始化bridge
function initJsBridge(readyCallback) {
  window.console.log("======开始初始化bridge======", Date.now());
  const u = navigator.userAgent;
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

  function connectWebViewJavascriptBridge(callback) {
    if (isAndroid) {
      if (window.WebViewJavascriptBridge) {
        //callback(WebViewJavascriptBridge)
        callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          () => {
            window.console.log("======完成初始化bridge======", Date.now());
            callback(window.WebViewJavascriptBridge);
          },
          false
        );
      }
      return;
    }
    if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        // return callback(WebViewJavascriptBridge)
        return callback(window.WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      const WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe);
        window.console.log(
          "======完成初始化bridge======",
          Date.now(),
          window.WebViewJavascriptBridge
        );
      }, 0);
    }
  }
  // 调用注册方法

  connectWebViewJavascriptBridge(bridge => {
    readyCallback(bridge);
  });
}

adminNative.initJsBridge = initJsBridge;

// 调起客户端方法  type  方法名  param 参数  responseCallBack 回调
function callHandleAppFunction(
  type,
  param = "",
  responseCallBack = emptyFunction
) {
  if (window.WebViewJavascriptBridge) {
    window.WebViewJavascriptBridge.callHandler(type, param, responseCallBack);
  } else {
    if (responseCallBack) {
      responseCallBack(false);
    }
  }
}

function readyJsBridge(cb) {
  const u = navigator.userAgent;
  const isApp = u.indexOf("yocial") > -1;
  if (isApp) {
    if (window.WebViewJavascriptBridge) {
      cb(window.WebViewJavascriptBridge);
    } else {
      initJsBridge(cb);
    }
  } else {
    cb(false);
  }
}

/**
 * 调用Native函数
 * @param name
 * @param data
 * @param options
 * @return {Promise<any>}
 */
export function callNative(
  name,
  data,
  options = {
    timeout: 0
  }
) {
  return new Promise((resolve, reject) => {
    let id;

    if (options.timeout) {
      id = setTimeout(() => reject('timeout'), options.timeout);
    }

    initJsBridge(bridge => {
      // 数据返回可能是 JS Object 或者 String
      bridge.callHandler(name, data, res => {
        if (id) clearTimeout(id);

        try {
          resolve(
            res && typeof res === 'string' ? JSON.parse(res) : res
          );
        } catch (e) {
          reject(e);
        }
      });
    });
  });
}

//调用原生获取sdkToken
adminNative.getSdkToken = function (param, callback) {
  readyJsBridge(bridge => {
    if (bridge) {
      callHandleAppFunction("jsGetRiskControlToken", param, callback);
    } else {
      errorCallback(1);
    }
  });
};

export default adminNative;



// WEBPACK FOOTER //
// ./src/assets/js/bridge.js